export const INITIAL_CUSTOMISATION_OPTIONS_STATE = {
  strap: {
    selected: "steelBlack",
    defaultViewIndex: 0,
  },
  case: {
    selected: "steelBlack",
    defaultViewIndex: 0,
  },
  bezel: {
    selected: "blackWhite",
    defaultViewIndex: 1,
  },
  dial: {
    selected: "black",
    defaultViewIndex: 1,
  },
  initials: {
    selected: "white",
    defaultViewIndex: 1,
    text: "",
  },
  stamp: {
    selected: "none",
    defaultViewIndex: 1,
  },
  twentyFour: {
    selected: "grey",
    defaultViewIndex: 1,
  },
  hands: {
    selected: "white",
    defaultViewIndex: 1,
  },
  seconds: {
    selected: "white",
    defaultViewIndex: 1,
  },
  engraving: {
    selected: null,
    defaultViewIndex: 3,
    text: "",
  },
};
